
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Santacruztopunecab() {



    const cardData =
    {
        keyword: 'Santacruz to Pune Cab ',
        heading: 'Skyline Cabs: Santacruz to Pune Cab',
        headingDescription: 'Skyline Cabs offers prompt and comfortable Santacruz to Pune Cab services for a seamless travel experience. Whether you are heading to Pune for work, leisure, or a family visit, our reliable drivers and well-maintained vehicles ensure a safe and hassle-free journey. With door-to-door pickup from Santacruz, affordable pricing, and 24/7 service, Skyline Cabs is your trusted partner for intercity travel. Book your Santacruz to Pune cab today and ride in comfort and confidence.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Santacruz to Pune Taxi Fare",
      "description": "Skyline Cabs offers affordable and transparent taxi fares from Santacruz to Pune. With options for sedans, Ertiga, and Innova Crysta, we provide clear upfront pricing that includes tolls, fuel, and driver charges—no hidden fees."
    },
    {
      "name": "Santacruz Airport to Pune Taxi Fare",
      "description": "Get the best rates for a taxi from Santacruz Airport to Pune with Skyline Cabs. Whether you're heading to Pune city or surrounding areas, we ensure competitive pricing and comfortable travel."
    },
    {
      "name": "Santacruz Airport to Pune One Way Taxi",
      "description": "Looking for a one-way drop from Santacruz Airport to Pune? Skyline Cabs offers quick, reliable, and cost-effective cab services with flexible scheduling and professional drivers."
    },
    {
      "name": "Mumbai to Pune Cab Booking",
      "description": "Book your Mumbai to Pune cab online with Skyline Cabs for a seamless travel experience. We offer 24/7 support, real-time tracking, and a fleet of clean, well-maintained vehicles for every need."
    },
    {
      "name": "Santacruz Airport to Pune Taxi Service",
      "description": "Skyline Cabs provides dependable taxi services from Santacruz Airport to Pune. Perfect for travelers arriving from domestic or international flights looking for hassle-free transfers."
    },
    {
      "name": "Santacruz to Pune by Taxi",
      "description": "Travel from Santacruz to Pune in comfort with Skyline Cabs. Our fleet includes everything from economical sedans to premium SUVs, all driven by trained chauffeurs for a safe journey."
    },
    {
      "name": "Santacruz to Pune Innova Crysta",
      "description": "Book a premium Innova Crysta for your journey from Santacruz to Pune with Skyline Cabs. Ideal for families and groups, enjoy spacious interiors and a smooth ride with AC comfort."
    },
    {
      "name": "Santacruz to Pune Ertiga Taxi",
      "description": "Need a mid-sized cab for your Pune trip? Choose Ertiga from Skyline Cabs for a budget-friendly yet spacious option. Perfect for airport transfers, outstation trips, and family travel."
    },
    {
      "name": "Santacruz to Pune Sedan Taxi",
      "description": "Skyline Cabs offers Swift Dzire, Etios, and Xcent sedan options from Santacruz to Pune. A comfortable and economical choice for individuals and small families."
    },
    {
      "name": "Mumbai International Airport to Pune Cab",
      "description": "Arriving at the Mumbai International Airport? Book a cab with Skyline Cabs for a direct transfer to Pune. Choose from a range of vehicles with on-time pickup and 24/7 customer support."
    },
    {
      "name": "Cab Service in Santacruz West",
      "description": "Skyline Cabs is the go-to cab service in Santacruz West. We provide airport transfers, intercity travel, and local cabs with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Best Cab Service in Santacruz",
      "description": "Looking for reliable cabs in Santacruz? Skyline Cabs is known for punctuality, cleanliness, and courteous service—whether it's a ride to Pune or a local trip in Mumbai."
    },
    {
      "name": "Santacruz Airport Cab Service",
      "description": "Skyline Cabs provides safe and prompt cab service from Santacruz Airport to Pune and other major destinations. Book one-way, round-trip, or outstation cabs with ease."
    },
    {
      "name": "Santa Cruz Airport Car Service",
      "description": "Get a private car service from Santa Cruz Airport to Pune. We offer luxury sedans and SUVs for travelers who want privacy, comfort, and convenience after a flight."
    },
    {
      "name": "Innova Crysta on Rent in Santacruz",
      "description": "Rent an Innova Crysta in Santacruz for your outstation travel needs. Ideal for families and group travel, Skyline Cabs ensures premium comfort and spacious seating with professional service."
    },
    {
      "name": "Ertiga on Rent in Santacruz",
      "description": "Book an Ertiga on rent from Santacruz to Pune or other outstation locations. Great for mid-size groups with luggage, the Ertiga offers comfort at a great value."
    },
    {
      "name": "Taxi Service in Santacruz",
      "description": "Skyline Cabs offers taxi services across Santacruz for airport drops, outstation rides, and city tours. Available 24/7 with a range of vehicles and expert drivers."
    },
    {
      "name": "Cab Service in Mumbai City",
      "description": "Skyline Cabs provides full-service taxi solutions across Mumbai, including airport pickups, Pune transfers, and business travel support with professional drivers and real-time GPS tracking."
    }
  ],
  "tableData": [
    ["Santacruz to Pune Taxi Fare", "Santacruz Airport to Pune Taxi Fare"],
    ["Santacruz Airport to Pune One Way Taxi", "Mumbai to Pune Cab Booking"],
    ["Santacruz Airport to Pune Taxi Service", "Santacruz to Pune by Taxi"],
    ["Santacruz to Pune Innova Crysta", "Santacruz to Pune Ertiga Taxi"],
    ["Santacruz to Pune Sedan Taxi", "Mumbai International Airport to Pune Cab"],
    ["Cab Service in Santacruz West", "Best Cab Service in Santacruz"],
    ["Santacruz Airport Cab Service", "Santa Cruz Airport Car Service"],
    ["Innova Crysta on Rent in Santacruz", "Ertiga on Rent in Santacruz"],
    ["Taxi Service in Santacruz", "Cab Service in Mumbai City"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Santacruz to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers dependable and punctual cab services from Santacruz to Pune, ensuring that you reach your destination safely and on time. Whether you're traveling for business, leisure, or visiting loved ones, our professional service ensures a smooth, stress-free journey."
    },
    {
        "WhyChooseheading": "Comfortable, Air-Conditioned Vehicles",
        "WhyChoosedescription": "Enjoy a comfortable ride from Santacruz to Pune in our clean, well-maintained, and air-conditioned vehicles. With spacious interiors, plush seating, and ample luggage space, our cabs are designed for a relaxing and enjoyable intercity travel experience."
    },
    {
        "WhyChooseheading": "Trained and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced, background-verified, and trained for long-distance travel. They are familiar with the Santacruz to Pune route, ensuring the most efficient path is taken while prioritizing your safety and comfort throughout the journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Fare Structure",
        "WhyChoosedescription": "Skyline Cabs offers highly competitive pricing with full transparency. You get to see the fare upfront—no hidden charges or surprise costs. Whether you're booking a one-way or round trip from Santacruz to Pune, our pricing is always fair and straightforward."
    },
    {
        "WhyChooseheading": "24/7 Availability for Any Schedule",
        "WhyChoosedescription": "Need an early morning pickup or a late-night drop? Skyline Cabs is available 24/7 to accommodate your schedule. Book a ride from Santacruz to Pune at any hour, and our reliable service will get you there on time, every time."
    },
    {
        "WhyChooseheading": "Vehicle Options for Every Travel Need",
        "WhyChoosedescription": "Whether you’re traveling alone, with family, or in a group, we have the perfect vehicle for you. Choose from economy sedans, spacious SUVs, or premium cars for a luxurious experience—Skyline Cabs has something for every traveler."
    },
    {
        "WhyChooseheading": "Seamless Online Booking and Tracking",
        "WhyChoosedescription": "Booking your Santacruz to Pune cab is fast and easy with our website or mobile app. Receive instant booking confirmation, track your driver in real time, and enjoy multiple payment options for a convenient and modern travel experience."
    },
    {
        "WhyChooseheading": "Safe and Secure Ride Every Time",
        "WhyChoosedescription": "Your safety is our top priority. All Skyline Cabs are GPS-enabled, thoroughly sanitized, and driven by verified professionals. Whether you’re traveling during the day or night, you can rely on us for a secure and worry-free journey from Santacruz to Pune."
    }
]


















    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Santacruz to Pune with Skyline Cabs?',
            answer:
                'You can book easily via our website or mobile app. Select Santacruz (East or West) as your pickup location and Pune as your destination. Choose your preferred car type and confirm your trip instantly.',
        },
        {
            id: 2,
            question: 'What types of cars are available for the Santacruz to Pune trip?',
            answer:
                'We offer a variety of options including Sedans, SUVs, Ertiga, Innova Crysta, and premium cars. Choose a vehicle that suits your travel style and group size.',
        },
        {
            id: 3,
            question: 'Are fares from Santacruz to Pune fixed and transparent?',
            answer:
                'Yes, our fares are fixed and include all charges — driver fees, tolls, and taxes. No hidden costs, just upfront pricing.',
        },
        {
            id: 4,
            question: 'Do you provide pickup from Santacruz Railway Station?',
            answer:
                'Absolutely! We provide direct pickups from Santacruz Railway Station and nearby locations. Mention your station details while booking for a smooth experience.',
        },
        {
            id: 5,
            question: 'How long does the Santacruz to Pune journey take?',
            answer:
                'The travel time is approximately 3.5 to 4 hours, depending on traffic. Our expert drivers use the fastest and safest routes to get you there on time.',
        },
        {
            id: 6,
            question: 'Is it possible to book a round-trip cab from Santacruz to Pune?',
            answer:
                'Yes, Skyline Cabs offers both one-way and round-trip bookings. Just mention your return date and we’ll handle the rest.',
        },
        {
            id: 7,
            question: 'Are Skyline Cabs available 24/7 from Santacruz to Pune?',
            answer:
                'Yes, we operate round-the-clock. Whether it’s an early morning meeting or a late-night flight, our cabs are always ready.',
        },
        {
            id: 8,
            question: 'Are the drivers experienced and professional?',
            answer:
                'All our drivers are trained, verified, and experienced in long-distance travel. They prioritize your safety and comfort throughout the trip.',
        },
        {
            id: 9,
            question: 'Can I make changes or cancel my booking?',
            answer:
                'Yes, you can modify or cancel your booking through our app, website, or by contacting customer support. We offer flexible policies to suit your plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs from Santacruz to Pune?',
            answer:
                'Skyline Cabs offers reliable service, clean and comfortable cars, fixed pricing, and courteous drivers — making your Santacruz to Pune journey smooth and stress-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ajay Kulkarni",
            rating: 5,
            review: "Booked a cab from Santacruz East to Pune for a business meeting. The car was spotless, the driver was well-mannered, and the trip was super smooth. Really impressed with Skyline Cabs!"
        },
        {
            name: "Miss. Tanya Desai",
            rating: 4,
            review: "I traveled from Santacruz West to Pune late in the evening. Booking was simple, the cab arrived on time, and the ride was comfortable. Only wish they had in-car Wi-Fi, but overall great experience!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Santacruz to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/santacruz-to-pune-cab.jpg",
  "description": "Book Santacruz to Pune cabs with Skyline Cabs for a reliable, affordable, and comfortable journey. Get 24/7 cab service with AC sedans or SUVs driven by verified chauffeurs—ideal for one-way or round-trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7378"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/santacruz-to-pune-cabs"
  }
};


      
     
      

    return (
        <div>
 <Helmet>
  <title>Santacruz to Pune Cabs | AC Sedan & SUV | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Santacruz to Pune cabs with Skyline Cabs for a reliable, affordable, and comfortable journey. Get 24/7 cab service with AC sedans or SUVs driven by verified chauffeurs—ideal for one-way or round-trip travel." 
  />
  <meta 
    name="keywords" 
    content="Santacruz to Pune Cabs, Cab from Santacruz to Pune, One-Way Taxi Santacruz to Pune, Round Trip Cab Santacruz to Pune, AC Cab Santacruz to Pune, SUV Taxi Santacruz to Pune, 24/7 Cabs Santacruz to Pune, Affordable Taxi Santacruz to Pune, Skyline Cabs Santacruz to Pune, Online Cab Booking Santacruz Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/35.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Santacruztopunecab;